export const getDisplayName = (firstName, lastName, userName) => {
  if (firstName && lastName) return firstName + ' ' + lastName;
  if (firstName) return firstName;
  if (lastName) return lastName;

  return userName || '';
};
